import { useNavigate } from 'react-router-dom';
import { ChevronDown } from 'lucide-react';
import {
  DropdownMenu,
  DropdownMenuTrigger,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuSeparator,
} from '@vnetwork/ui/primitives';
import { useTheme } from '@vnetwork/ui/provider';
import { useAuth } from '@/auth/AuthProvider';
import { brand } from '@/config/brand';
import { SunIcon, MoonIcon, AccountIcon, KeyIcon, SignOutIcon } from './shell-icons';
import styles from './UserMenu.module.css';

export function UserMenu() {
  const navigate = useNavigate();
  const [theme, setTheme] = useTheme();
  const { user, logout } = useAuth();

  const initial = (user?.name ?? user?.email ?? '?').charAt(0).toUpperCase();
  const isDark = theme === 'dark';

  return (
    <div className={styles.actions}>
      <button
        type="button"
        aria-label="Toggle theme"
        title={isDark ? 'Switch to light' : 'Switch to dark'}
        className={styles.iconBtn}
        onClick={() => setTheme(isDark ? 'light' : 'dark')}
      >
        {isDark ? (
          <SunIcon size={16} color="var(--vn-warning-solid)" />
        ) : (
          <MoonIcon size={16} color="var(--vn-fg-muted)" />
        )}
      </button>

      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <button type="button" aria-label="Account menu" className={styles.trigger}>
            <span aria-hidden className={styles.avatar}>
              {initial}
            </span>
            <ChevronDown size={12} strokeWidth={2.5} color="var(--vn-fg-subtle)" />
          </button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" sideOffset={8} className={styles.menu}>
          <div className={styles.email}>{user?.email ?? 'Account'}</div>
          <DropdownMenuItem className={styles.menuItem} onSelect={() => navigate('/account')}>
            <AccountIcon size={16} />
            Account
          </DropdownMenuItem>
          {brand.features.apiKeys && (
            <DropdownMenuItem
              className={styles.menuItem}
              onSelect={() => navigate('/account/api-keys')}
            >
              <KeyIcon size={16} />
              API keys
            </DropdownMenuItem>
          )}
          <DropdownMenuSeparator className={styles.separator} />
          <DropdownMenuItem className={styles.menuItem} onSelect={() => logout()}>
            <SignOutIcon size={16} />
            Sign out
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    </div>
  );
}
